import {motion} from "framer-motion";
import {ActionButton, AddToCart} from "../../../components/buttons";
import React, {useCallback} from "react";
import {useStoreState} from "pullstate";
import {AppCall, getCallStates, getProduct, getVapi, resetCall, resetTranscript, updateCall,} from "../../../stores";
import {ASSISTANT_NAME} from "../../../config";
import {MicOffIcon, MicOnIcon, TelOffIcon, TelOnIcon} from "../../../components/icons";
import {AIAssistant} from "../../../assistant";

interface Props extends React.ComponentProps<typeof motion.div> {
    audio: HTMLAudioElement;
}

export const CallButtons: React.FC<Props> = ({audio, ...props}) => {
    //--- Start States
    const vapi = useStoreState(AppCall, getVapi);
    const product = useStoreState(AppCall, getProduct);
    // const call = useStoreState(AppCall, getCall);
    const states = useStoreState(AppCall, getCallStates);
    //--- End States

    //--- Start Getters
    // TODO: Add getters here
    //--- End Getters

    //--- Start Actions
    const startRing = useCallback(() => {
        audio.loop = true;
        audio.play();
    }, [audio]);

    const startCall = async () => {
        startRing();
        AppCall.update((state) => ({
            ...state,
            isCalling: true,
        }));

        const assistant = new AIAssistant(product, ASSISTANT_NAME);

        try {
            console.log("Call started");
            const details = assistant.create();
            const res = await vapi.start(details);
            if (res) {
                resetTranscript();
                updateCall(res);
                console.log("Call ID: ", res.id, "Customer ID: ", res.customerId);
            }
        } catch (err) {
            resetCall();
        } finally {
            //
        }
    };

    const endCallButtonClicked = () => {
        vapi.stop();
    };

    const muteUnmuteCall = () => {
        const muted = !(vapi.isMuted());
        vapi.setMuted(muted);
        AppCall.update((state) => ({
            ...state,
            muted,
        }));
    };
    //--- End Actions

    //--- Start watchers
    //
    //--- End watchers

    return (
        <motion.div className="grid grid-cols-12 gap-4" {...props}>
            <div className="col-span-6">
                <ActionButton
                    buttonClass="w-full"
                    color={states.callInProgress ? "danger" : "success"}
                    variant={states.callInProgress ? "default" : "outlined"}
                    icon={states.callInProgress ? <TelOffIcon/> : <TelOnIcon className="w-5 h-5"/>}
                    onClick={states.callInProgress ? endCallButtonClicked : startCall}
                >
                    {states.callInProgress ? "Fin d'appel" : "Lancer l'appel"}
                </ActionButton>
            </div>
            <div className={`col-span-6 text-sm ${states.inCall ? "block" : "hidden"}`}>
                <ActionButton
                    buttonClass="w-full"
                    color="tertiary"
                    variant="outlined"
                    icon={states.muted ? <MicOffIcon/> : <MicOnIcon/>}
                    onClick={muteUnmuteCall}
                >
                    {states.muted ? "Réactiver" : "Couper"} l'appel
                </ActionButton>
            </div>
            <div
                className={`col-span-full ${
                    states.showAddToCart && states.callInProgress ? "block" : "hidden"
                }`}
            >
                <AddToCart buttonClass="w-full" variant="outlined"/>
            </div>
        </motion.div>
    );
};
